export default __webpack_public_path__ + "static/media/logo.760bf5e9.svg";